export class FormConditionalLogic {
  TemplateID: string = '';
  ChartJson: any;
  SectionConditions: SectionConditions[] = [];
}

export class SectionConditions {
  SectionUniqueID: string = '';
  ConditionalLogic: ConditionalLogic[] = [];
}

export class ConditionalLogic {
  SourceQuestinID: string = '';
  ConditionsExist: boolean = false;
  Mandatory: boolean = false;
  Name: string = '';
  AllowScoring: boolean = false;
  DisplayOrder: number = 0;
  Conditions: NavigationData[] = [];
  constructor() {}
}

export class NavigationData {
  UniqueID: string = '';
  EdgeRefID: string = '';
  EdgeValue: string = '';
  DestinationQuestionID: string = '';
  MandatoryDependantQuestion: string[] = [];
  Score: number = 0;

  constructor() {}
}
